import http from 'services/http'
import { buildUrl } from 'app/utils'

const url = buildUrl('/contrato/avaliacoes-satisfacao-sistema')

export const sendFeedbackRating = params => http.post(url('avaliar'), params)

export default {
  sendFeedbackRating
}
